class CustomSelect extends HTMLElement {
  constructor() {
    super();
    this.ELM_select = this.querySelector('select');
    this.ELM_customOptionsList = this.querySelectorAll('li');
    this.ELM_customSelectSelected = this.querySelector('[data-custom-select-selected]');
    this.ELM_cardWrapper = this.closest('.card--show-modal-bis');
    this.modalBisId = this.dataset.modalBis;
    this.ELM_modalBis = document.querySelector(`#${this.modalBisId}`);
    this.ELM_modalSelect = this.ELM_modalBis?.querySelector('select');

    this.addEventListener('click', (e) => {
      if(!e.target.classList.contains('active')) {
        document.querySelector('.custom-select.active')?.classList.remove('active');
      }
      e.target.classList.toggle('active');
    });

    this.ELM_customOptionsList.forEach(elm => {
      elm.addEventListener('click', e => {
        const elm = e.target;
        const text = elm.innerHTML;

        this.ELM_select.value = elm.dataset.value;
        this.ELM_select.dispatchEvent(new Event('change'));
        if (text) {
          this.ELM_customSelectSelected.querySelector('span').innerHTML = text;
        };

        if (elm.hasAttribute('data-disabled')) {
          this.ELM_cardWrapper?.classList.add('card--oos');
        } else {
          this.ELM_cardWrapper?.classList.remove('card--oos');
        }

        if (this.ELM_modalSelect) {
          this.ELM_modalSelect.value = this.ELM_select.value;
        }

        this.closest('.form-variant-selector')?.querySelector('[name="id"]')?.setAttribute('value', `${this.ELM_select.value}`);
      });
    })
  }
}

customElements.define('custom-select', CustomSelect);
